import React, { useState, useEffect } from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import styles from "./FilterBoosters.module.css";
import globalStyles from "../../../styles/globalStyles.module.css";
import { boosterData } from "../../../services/BoosterServices";
import { sortOrderEnum } from "../../../enums/sortOrderEnum";
import { useTranslation } from "react-i18next";

const FilterBoosters: React.FC<{
  boosters: boosterData[];
  handleFilterBoosters: (boosters: boosterData[]) => void;
}> = ({ boosters, handleFilterBoosters }) => {
  const [textFilter, setTextFilter] = useState<string>(""); // Default selected value
  const [sortOrder, setSortOrder] = useState<sortOrderEnum | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    let updatedBoosters = boosters;

    if (textFilter) {
      updatedBoosters = updatedBoosters.filter((booster) =>
        booster.name.toLowerCase().includes(textFilter.toLowerCase())
      );
    }

    updatedBoosters = updatedBoosters.sort((a, b) => {
      const comparison = a.name.localeCompare(b.name);
      return sortOrder === "ASC" ? comparison : -comparison;
    });

    handleFilterBoosters(updatedBoosters);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textFilter, sortOrder]);

  const toggleSortOrder = () => {
    if (sortOrder === sortOrderEnum.ascending) {
      setSortOrder(sortOrderEnum.descending);
      return;
    }
    if (sortOrder === sortOrderEnum.descending) {
      setSortOrder(null);
      return;
    }
    if (sortOrder === null) {
      setSortOrder(sortOrderEnum.ascending);
      return;
    }
  };

  return (
    <div
      className="d-flex justify-content-end align-items-center gap-2"
      style={{ margin: "10px" }}
    >
      {textFilter && (
        <button
          className={`${styles.iconButton} ${
            sortOrder !== null ? styles.activeIcon : ""
          }`}
          onClick={toggleSortOrder}
        >
          {sortOrder === sortOrderEnum.ascending ? (
            <FaArrowUp />
          ) : (
            <FaArrowDown />
          )}
        </button>
      )}

      <input
        type="text"
        className={`${globalStyles.input} w-25`}
        value={textFilter}
        onChange={(e) => setTextFilter(e.target.value)}
        placeholder={t("boosters.filter.name")}
      />
    </div>
  );
};

export default FilterBoosters;
